import React from 'react';

import Banner from '../components/Banner';
import Footer from '../components/Footer';
import styles from './Page.module.css';

const WeldingSkill = () => {
    return (
        <div className='Page WeldingSkill'>
            <Banner title={`Welding (TIG)`} custom={true} />
            <section className={styles.section}>

            </section>
            <Footer></Footer>
        </div>
    );
};

export default WeldingSkill;